// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-in';

export const Component = () => (
  <path d='m12.925 16.81 4.071-4.07H1.48c-.335 0-.479-.145-.479-.48 0-.335.144-.479.479-.479h15.517l-4.071-4.07a.434.434 0 0 1-.144-.336c0-.335.144-.527.48-.527.047 0 .143.048.334.144l4.933 4.933c.096.191.144.287.144.335 0 .048-.048.144-.144.335l-4.933 4.933c-.143.048-.239.096-.335.096-.335 0-.479-.144-.479-.479 0-.143.048-.239.144-.335ZM22.073 0H11.297a1.41 1.41 0 0 0-1.054.431 1.408 1.408 0 0 0-.431 1.054v3.927c0 .336.191.48.526.48s.48-.144.48-.48V1.485c0-.335.143-.526.478-.526h10.776c.335 0 .526.191.526.526v21.552c0 .335-.191.479-.526.479H11.296c-.335 0-.479-.144-.479-.48V19.11c0-.335-.144-.479-.479-.479-.335 0-.526.144-.526.48v3.927c0 .431.143.766.431 1.054.287.287.623.43 1.054.43h10.776c.43 0 .766-.143 1.054-.43a1.41 1.41 0 0 0 .43-1.054V1.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 22.073 0Z' />
);

export const viewBox = '0 0 25 25';
